import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center space-x-3 p-2" }
const _hoisted_2 = { class: "flex-grow flex flex-wrap items-center" }
const _hoisted_3 = { class: "flex-grow font-medium" }
const _hoisted_4 = {
  key: 0,
  class: "font-bold text-green-500 flex items-center"
}
const _hoisted_5 = {
  key: 1,
  class: "font-bold text-red-500 flex items-center"
}
const _hoisted_6 = {
  key: 1,
  class: "bg-gray-200 dark:bg-gray-900 truncate max-w-xs px-1 font-mono rounded text-gray-500 dark:text-gray-300 text-sm"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-full mt-1" }, null, -1)
const _hoisted_8 = { class: "flex-grow" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["datetime"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_account_link = _resolveComponent("account-link")!
  const _component_near_symbol = _resolveComponent("near-symbol")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.iconBgColor, "w-9 h-9 flex-shrink-0 relative rounded-full text-white"])
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon), { class: "w-6 h-6 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" }))
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$filters.humanize.actionKind(_ctx.action.action_kind)) + " ", 1),
        (_ctx.otherAccount !== null)
          ? (_openBlock(), _createBlock(_component_account_link, {
              key: 0,
              account: _ctx.otherAccount,
              class: "truncate inline-block align-bottom max-w-xs"
            }, null, 8, ["account"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.nearValue !== null)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.incoming)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.$filters.number.standard(+_ctx.$filters.toNear(_ctx.nearValue))) + " ", 1),
                  _createVNode(_component_near_symbol, { class: "w-5 h-full" })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createTextVNode(" −" + _toDisplayString(_ctx.$filters.number.standard(+_ctx.$filters.toNear(_ctx.nearValue))) + " ", 1),
                  _createVNode(_component_near_symbol, { class: "w-5 h-full" })
                ]))
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.textValue !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.textValue), 1))
        : _createCommentVNode("", true),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("a", {
          href: _ctx.transactionExplorerUrl,
          target: "_blank",
          rel: "noreferrer",
          class: "truncate text-sm text-gray-500 dark:text-gray-400"
        }, _toDisplayString(_ctx.action.transaction_hash), 9, _hoisted_9)
      ]),
      _createElementVNode("time", {
        class: "text-sm text-gray-500 dark:text-gray-400",
        datetime: _ctx.$filters.nearTimestampToISO(_ctx.action.block_timestamp)
      }, _toDisplayString(_ctx.$filters.nearTimestampToLocaleString(
            _ctx.action.block_timestamp,
            _ctx.DateTime.DATETIME_MED,
          )), 9, _hoisted_10)
    ])
  ]))
}